// Modelos de cobrança disponíveis
export const BILLING_MODELS = {
  POR_TE: 'por_te',
  POR_PRENHEZ: 'por_prenhez',
  DIARIA: 'diaria',
  PACOTE_COMPLETO: 'pacote_completo',
  POR_EMBRIAO: 'por_embriao',
  PERSONALIZADO: 'personalizado',
  // Serviço que faz o trabalho mas não é cobrado: o faturamento corre noutro.
  // Não é "valor zero" — é afirmar que aqui não há o que cobrar.
  SEM_COBRANCA: 'sem_cobranca'
};

export const BILLING_MODEL_LABELS = {
  por_te: 'Por Transferência de Embrião (TE)',
  por_prenhez: 'Por Prenhez Confirmada',
  diaria: 'Diária de Serviço',
  pacote_completo: 'Pacote Completo',
  por_embriao: 'Por Embrião Produzido',
  personalizado: 'Personalizado',
  sem_cobranca: 'Sem cobrança (faturado em outro serviço)',
};
